import { OperatorPortalWorkPage } from "@/components/non_registrant/operator-portal-pages";
import { withPaymentListViewSearch } from "@/lib/payment-list-view";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/checks")({
  validateSearch: withPaymentListViewSearch,
  component: OperatorPortalWorkPage,
});
